module.exports = __webpack_public_path__ + "static/isg-banner-6aaf76c37a1996b11831baf9efef520f.png";